var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { customElement, property } from 'lit/decorators.js';
import { DatahubLayer } from './datahub-layer.js';
import { Translate } from '../../utils/translate.js';
import { DatahubService } from './datahub.service.js';
import { DatahubPickerEvent } from './datahub-picker.event.js';
let DataHubPickerComponent = class DataHubPickerComponent extends GGOBaseComponent {
    constructor() {
        super();
        this.datahubUrl = 'https://datahub.galigeo.com';
        this.orgId = '';
        this.datahubLayer = new DatahubLayer();
    }
    async init() { }
    openDatahub() {
        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.border = 'none';
        iframe.style.zIndex = '9999';
        // Définir l'URL de l'iframe à this.datahubUrl
        iframe.src = this.datahubUrl + '?orgId=' + this.orgId;
        window.addEventListener('message', async (e) => {
            const data = JSON.parse(e.data);
            if (data.fields) {
                data.fields = data.fields.map((field) => field.name);
                const datahubSelecttion = data;
                if (datahubSelecttion.action === 'refresh') {
                    this.datahubLayer = await DatahubService.datahubSelectionToDatahubLayer(this.datahubUrl, datahubSelecttion);
                    this.dispatchEvent(new DatahubPickerEvent(this.datahubLayer));
                }
            }
            // destroy the iframe
            iframe.remove();
        });
        iframe.onload = () => {
            if (this.datahubLayer?.fields?.length > 0) {
                setTimeout(() => {
                    const datahubSelection = DatahubService.datahubLayerToDatahubSelection(this.datahubUrl, this.datahubLayer);
                    datahubSelection.action = 'editSelection';
                    iframe?.contentWindow?.postMessage(JSON.stringify(datahubSelection), this.datahubUrl);
                }, 2000);
            }
        };
        // Ajouter l'iframe au document.body
        document.body.appendChild(iframe);
    }
    render() {
        let label;
        if (this.datahubLayer?.fields?.length > 5) {
            label = `${this.datahubLayer.alias} (${this.datahubLayer.fields.length} ${Translate.get('datahub_fields')})`;
        }
        else if (this.datahubLayer?.fields?.length > 0) {
            label = this.datahubLayer.alias + ' - ' + this.datahubLayer.fields.map((f) => f.alias).join(', ');
        }
        else {
            label = Translate.get('datahub_pickup_indicator');
        }
        return html ` <ggo-button label="${label}" @click="${this.openDatahub}"></ggo-button> `;
    }
};
__decorate([
    property({ type: String })
], DataHubPickerComponent.prototype, "datahubUrl", void 0);
__decorate([
    property({ type: String })
], DataHubPickerComponent.prototype, "orgId", void 0);
__decorate([
    property({ type: Object })
], DataHubPickerComponent.prototype, "datahubLayer", void 0);
DataHubPickerComponent = __decorate([
    customElement('ggo-datahub-picker')
], DataHubPickerComponent);
export { DataHubPickerComponent };
